interface ButtonArrowProps {
    color: string;
}

const ButtonArrow = ({ color }: ButtonArrowProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.758424 14.1582C0.985924 14.3861 1.28459 14.5 1.58311 14.5C1.8817 14.5 2.1803 14.387 2.40817 14.1573L8.24149 8.32435C8.69723 7.86867 8.69723 7.13043 8.24149 6.67473L2.40817 0.841776C1.95243 0.386075 1.21415 0.386075 0.758424 0.841776C0.302693 1.29747 0.302693 2.03571 0.758424 2.49141L5.76853 7.50045L0.758424 12.5086C0.302693 12.9643 0.302693 13.7025 0.758424 14.1582Z"
                fill={color}
            />
        </svg>
    );
};

export default ButtonArrow;
